module.exports = __webpack_public_path__ + "static/img/no-overdraft.8c1b477.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-overdraft.png
// module id = 5Cfm
// module chunks = 6